import defaultTo from 'lodash/defaultTo';

const { REACT_APP_CUSTOMER_TENANT } = process.env;

export default {
  customerTenant: defaultTo(REACT_APP_CUSTOMER_TENANT, ''),
};
